module.exports = __webpack_public_path__ + "img/08.3eafc987.png";